import React from 'react'
import gif from '../Document/404.gif'
import { NavLink } from "react-router-dom";

export const PageNotFound = () => {
    document.title = "Lishal Bhari | 404 Error!";
    return (
      <div className="lis-container">
        <div className="lis-404">
        <h1>Oops! Page not found.</h1>
        <img src={gif} alt="404 | Page not found!" height={300} width={450} />
        <h1>We can't find the page you are looking for.</h1>
        <NavLink to="/">
            <button className='lis-404_btn'>
            Go To Home
            </button>
        </NavLink>
        </div>
        
      </div>
    );
  };
  